import { z } from 'zod'

import {
  bunkerSchema,
  laboratorySchema,
  validateRobBunkerTab,
} from './tabs/RobBunkerTab/robBunkerTabSchema'
import { fuelTanksSchema } from './tabs/RobFuelTanksTab/robFuelTanksTabSchema'
import { generalTabSchema } from './tabs/RobGeneralTab/robGeneralTabSchema'
import { sludgeOilBilgeSchema } from './tabs/RobSludgeOilBilgeTab/robSludgeOilBilgeTabSchema'

export const robSurveySchema = z
  .object({
    bunker: bunkerSchema,
    fuelTanks: fuelTanksSchema,
    general: generalTabSchema,
    laboratory: laboratorySchema,
    sludgeOilBilge: sludgeOilBilgeSchema,
  })
  .superRefine(validateRobBunkerTab)
